<template>
  <div class="forum">
    <div class="bread" v-if="$identity.name == 'student'">
      <router-link
        :to="{ name: fromRoute.name, query: { tab: fromRoute.tab } }"
      >
        {{ fromRoute.label }}
      </router-link>
      <span class="slash">/</span>
      <span class="current">圈子主页</span>
    </div>
    <div class="forum-box">
      <div class="left">
        <div class="group-info">
          <div class="info">
            <div class="img-wrap">
              <ScaleImage class="img" :src="groupInfo.image" />
            </div>
            <div class="content">
              <div class="name">
                <span>{{ groupInfo.name }}</span>
              </div>
              <p class="number">
                <span>帖子数{{ groupInfo.post_num }}</span>
                <span class="user">成员{{ groupInfo.user_num }}</span>
              </p>
              <div class="broadcast">
                <p
                  class="message"
                  v-if="
                    groupInfo.introduction && groupInfo.introduction.length > 89
                  "
                >
                  <span class="title">圈子介绍：</span>
                  {{
                    groupInfo.introduction
                      ? groupInfo.introduction.slice(0, 89)
                      : ""
                  }}...
                </p>
                <p class="message" v-else>
                  <span class="title">圈子介绍：</span>
                  {{ groupInfo.introduction }}
                </p>
                <p
                  class="moreIntro"
                  @click="
                    dialogIntroVisible = true;
                    isNotice = false;
                  "
                  v-if="
                    groupInfo.introduction && groupInfo.introduction.length > 89
                  "
                >
                  更多
                </p>
              </div>
            </div>
          </div>
          <div class="button-group">
            <p
              class="publish back"
              @click="outGroup"
              v-if="groupInfo.is_user_add == 1"
            >
              退出圈子
            </p>
            <p
              class="publish"
              @click="addGroup"
              v-if="groupInfo.is_user_add == 2"
            >
              加入圈子
            </p>

            <p
              class="publish"
              @click="targetPost"
              v-if="groupInfo.is_user_add == 1"
            >
              发布帖子
            </p>
          </div>
        </div>
        <div class="bbs-box">
          <!-- 版块 -->
          <el-tabs
            class="el-tabs-commounity el-tabs-community-active"
            v-model="plate_id"
            v-if="blocks.length"
          >
            <el-tab-pane
              :label="item.name"
              :name="String(item.id)"
              v-for="item in blocks"
              :key="item.id"
            ></el-tab-pane>
          </el-tabs>
          <div class="select">
            <SelectItem
              :items="selectItems"
              @handleClick="handleClick"
            ></SelectItem>
          </div>
          <ul class="forum-list">
            <CommunityCircleItem
              @complaint="onComplaint"
              :group_id="Number($route.params.id)"
              :plate_id="String(plate_id)"
              :activeTab="activeTab"
              origin="2"
            ></CommunityCircleItem>
          </ul>
        </div>
      </div>
      <div class="right">
        <!-- <button @click="targetPost" type="button" class="post">
          <span>发帖</span>
        </button> -->
        <div class="mine m-notice">
          <p class="title">
            圈子公告

            <span
              @click="
                dialogIntroVisible = true;
                isNotice = true;
              "
            >
              更多
            </span>
            <i
              @click="
                dialogIntroVisible = true;
                isNotice = true;
              "
            ></i>
          </p>
          <p class="no-login" v-if="!groupInfo.announcement">
            <span class="emptyTip">暂无公告～</span>
          </p>
          <div class="notice" v-else>{{ groupInfo.announcement }}</div>
        </div>
        <div class="mine m-user">
          <div class="title">
            <p>圈子成员</p>
            <div class="changePage">
              <img
                src="@/assets/images/icon-left.png"
                alt=""
                @click="prevPage"
              />
              <img
                src="@/assets/images/icon-right.png"
                alt=""
                @click="nextPage"
              />
            </div>
          </div>
          <p class="no-login" v-if="!groupUser.length">
            <span class="emptyTip">暂无成员～</span>
          </p>
          <el-row class="team" :gutter="16" v-else>
            <el-col :span="12" v-for="item in groupUser" :key="item.id">
              <div class="grid-content">
                <div class="img">
                  <img :src="item.avatar" />
                </div>
                <p class="eps">{{ item.nickname }}</p>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <Complaint ref="complaint"></Complaint>
    <PostConfirm
      :visible.sync="postVisible"
      :groupId="$route.params.id"
      origin="2"
    ></PostConfirm>
    <el-dialog
      :title="isNotice ? '圈子公告' : '圈子介绍'"
      :visible.sync="dialogIntroVisible"
      width="800px"
      class="dialog-complaint"
      :show-close="false"
    >
      <p>{{ isNotice ? groupInfo.announcement : groupInfo.introduction }}</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogIntroVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CommunityCircleItem from "./components/CommunityCircleItem";
import Complaint from "./components/Complaint.vue";
import PostConfirm from "./components/PostConfirm.vue";
import SelectItem from "./components/SelectItem";
import ScaleImage from "@/components/ScaleImage";
export default {
  name: "CommunityGroupShow",
  components: {
    CommunityCircleItem,
    Complaint,
    PostConfirm,
    SelectItem,
    ScaleImage,
  },
  data() {
    return {
      blocks: [], //版块
      selectItems: [
        { key: "hot", title: "最热" },
        { key: "new", title: "最新" },
      ],
      plate_id: "all",
      fromRoute: {
        name: this.$route.query.routeName || "Community",
        label: this.$route.query.routeLabel || "圈子",
        tab: this.$route.query.tab || null,
      },
      activeTab: "hot", //最新/最热
      groupInfo: {}, //小组信息
      groupUser: [], //小组成员
      userPage: 1, //圈子成员分页
      userLimit: 20, //圈子成员分页限制
      dialogIntroVisible: false, //圈子介绍弹窗
      postVisible: false, //发帖弹窗
      isNotice: false, //是否为公告
    };
  },
  async created() {
    await this.getGroupInfo();
    await this.getGroupUser();
  },
  mounted() {
    this.$http
      .get(
        `/api/${this.$identity.getCommunityClientApiLetter()}/community/plate`,
        {
          group_id: this.$route.params.id,
        },
      )
      .then(res => {
        this.blocks = res.plates || [];
        this.blocks.unshift({ id: "all", name: "全部" });
      });
  },
  methods: {
    //this.$route.params.id 为小组id
    // 热门最新话题切换
    handleClick(data) {
      this.activeTab = data;
    },
    //获取小组信息
    async getGroupInfo() {
      const that = this;
      let data = await that.$http.get(
        `/api/${this.$identity.getCommunityClientApiLetter()}/community/group/detail/` +
          this.$route.params.id,
        {
          page: that.userPage,
          limit: that.userLimit,
        },
      );
      that.groupInfo = data;
    },

    //获取小组成员
    async getGroupUser() {
      const that = this;
      let data = await that.$http.get(
        `/api/${this.$identity.getCommunityClientApiLetter()}/community/group/groupUsers/` +
          this.$route.params.id,
        {
          page: that.userPage,
          limit: that.userLimit,
        },
      );
      that.groupUser = data.data;
    },
    // 成员上一页
    prevPage() {
      if (this.userPage > 1) {
        this.userPage--;
        this.getGroupUser();
      }
    },
    // 成员下一页
    nextPage() {
      if (this.groupUser.length < 20) return;
      this.userPage++;
      this.getGroupUser();
    },
    // 跳转发帖
    targetPost() {
      const that = this;
      if (that.$store.state.token) {
        if (that.groupInfo.is_user_add == 2) {
          that.$message({
            type: "danger",
            message: "请先加入圈子",
          });
          return;
        }
        this.postVisible = true;
      } else {
        that.$router.push({
          name: "Login",
        });
      }
    },

    // 加入小组
    async addGroup() {
      const that = this;
      if (that.$store.state.token) {
        await that.$http.get(
          `/api/${this.$identity.getCommunityClientApiLetter()}/community/group/addGroup/` +
            this.$route.params.id,
        );
        that.getGroupInfo();
        that.getGroupUser();
        that.$message({
          type: "success",
          message: "加入成功！",
        });
      } else {
        that.$router.push({
          name: "Login",
        });
      }
    },

    // 取消加入
    async outGroup() {
      const that = this;
      if (that.$store.state.token) {
        await this.$confirm(
          "退出后该圈子将从我的圈子中移除，确定退出该圈子吗？",
          "提示",
          {
            type: "warning",
            customClass: "confirm-common",
          },
        );
        await that.$http.get(
          `/api/${this.$identity.getCommunityClientApiLetter()}/community/group/outGroup/` +
            this.$route.params.id,
        );
        that.getGroupInfo();
        that.getGroupUser();
        that.$message({
          type: "success",
          message: "退出成功！",
        });
      } else {
        that.$router.push({
          name: "Login",
        });
      }
    },
    onComplaint(item) {
      this.$refs.complaint.show(4, item.id);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.forum {
  padding-bottom: 24px;
  background-color: #f5f7f9;
  overflow: hidden;
  /deep/ {
    .el-pagination {
      margin: 25px 0;
    }
  }
  .bread {
    width: 100%;
    margin-right: auto;
    margin-left: auto;
    box-sizing: border-box;
    .slash {
      margin-left: 2px;
    }
  }

  .forum-box {
    overflow: hidden;
    width: 100%;
    margin: 0 auto;
    .left {
      float: left;
      width: 896px;
      border-radius: 5px;
      overflow: hidden;
      .group-info {
        margin: 0 auto 16px;
        padding: 24px;
        border-radius: 4px;
        box-sizing: border-box;
        // box-shadow: 0 16px 20px 0 rgba(0, 0, 0, 0.07);
        background-color: #fff;
        position: relative;
        .button-group {
          display: flex;
          align-items: center;
          position: absolute;
          right: 24px;
          top: 24px;
          .publish {
            width: 96px;
            height: 36px;
            line-height: 35px;
            text-align: center;
            color: #fff;
            background: #bb1c20;
            border-radius: 4px;
            cursor: pointer;
            box-sizing: border-box;
            border: 1px solid #bb1c20;
          }
          .back {
            background: #fff;
            border: 1px solid #bfbfbf;
            color: #666;
            margin-right: 10px;
          }
        }
        .info {
          overflow: hidden;
          .img-wrap {
            float: left;
            width: 120px;
            height: 120px;
            overflow: hidden;
            margin-right: 24px;
            border: 1px solid #e7e7e7;
            .img {
              width: 100%;
              height: 100%;
            }
          }
          .content {
            margin-left: 110px;
            width: auto;
            .name {
              font-size: 16px;
              font-weight: 600;
              color: #333;
              line-height: 26px;
            }
            .number {
              margin-top: 8px;
              font-size: 13px;
              color: #999;
              line-height: 14px;
              .user {
                position: relative;
                display: inline-block;
                margin-left: 12px;
              }
            }
            button.add {
              margin-top: 15px;
              width: 80px;
              height: 23px;
              line-height: 21px;
              background: $primary-color-1;
              border: none;
              border-radius: 12px;
              text-align: center;
              font-size: 13px;
              color: $primary-color;
              cursor: pointer;
              outline: none;
              &:hover {
                background: $primary-color;
                color: #fff;
              }
            }
            button.out {
              margin-top: 15px;
              width: 80px;
              height: 23px;
              line-height: 21px;
              background: #f4f4f4;
              border: none;
              border-radius: 12px;
              text-align: center;
              font-size: 13px;
              color: #8c8c8c;
              cursor: pointer;
              outline: none;
              &:hover {
                color: #000000;
              }
            }
            .broadcast {
              margin-top: 22px;
              position: relative;
              .message {
                height: 40px;
                overflow: hidden;
                font-size: 14px;
                color: #999;
                flex: 1;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                .title {
                  font-size: 14px;
                  color: #666;
                  width: 100px;
                }
              }
              .moreIntro {
                color: $primary-color;
                position: absolute;
                right: 0;
                bottom: 0;
                cursor: pointer;
              }
            }
          }
        }
      }
      .bbs-box {
        background-color: #fff;
        overflow: hidden;
        padding: 12px 24px;
        position: relative;
        border-radius: 4px;
        .forum-list {
          box-sizing: border-box;
        }
        .select {
          position: absolute;
          top: 32.5px;
          right: 25px;
          transform: translateY(-50%);
          display: flex;
          align-items: center;
          .label {
            margin-right: 10px;
          }
        }
      }
    }
    .right {
      margin-left: 912px;
      width: auto;
      .post {
        display: block;
        width: 100%;
        padding: 0 0 0 130px;
        height: 60px;
        line-height: 60px;
        border: none;
        box-shadow: 0px 6px 20px 0px $primary-color-04,
          0px 13px 33px 0px rgba(0, 0, 0, 0.04);
        border-radius: 32px;
        background: url("~@/assets/images/icon_fourm_post.png") 180px center
          no-repeat #fff;
        background-size: 18px 18px;
        text-align: left;
        font-size: 20px;
        color: #595959;
        outline: none;
        cursor: pointer;
        &:hover {
          background: url("~@/assets/images/icon_fourm_post_active.png") 180px
            center no-repeat $primary-color;
          background-size: 18px 18px;
          color: #fff;
        }
      }
      .mine {
        padding: 0 16px;
        background-color: #fff;
        border-radius: 4px;
        .title {
          position: relative;
          height: 50px;
          font-size: 16px;
          color: #333;
          line-height: 50px;
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-weight: bold;
          span {
            font-size: 14px;
            color: #666;
            margin-right: 10px;
          }
          i {
            position: absolute;
            top: 18px;
            right: 0;
            display: block;
            width: 6px;
            height: 12px;
            background: url("~@/assets/images/icon_fourm_right_arrow.png")
              center no-repeat;
            background-size: 100% 100%;
          }
        }
        .no-login {
          display: block;
          height: 147px;
          background: url("~@/assets/images/community/no_login_bg.png") center
            no-repeat #fff;
          background-size: 221px 154px;
          line-height: 250px;
          text-align: center;
          font-size: 14px;
          color: #999;
          margin-top: 20px;
          span {
            color: $primary-color;
            margin-left: 22px;
          }
          .emptyTip {
            color: #999;
          }
        }
      }
      .m-notice {
        overflow: hidden;
        margin-bottom: 16px;
        padding-bottom: 16px;
        .notice {
          max-height: 170px;
          overflow: hidden;
          font-size: 14px;
          color: #666;
          line-height: 24px;
          box-sizing: border-box;
        }
      }
      .m-user {
        padding: 0 16px 0;
        overflow: hidden;
        .changePage {
          display: flex;
          align-items: center;
          img {
            width: 22px;
            height: 22px;
            margin-left: 4px;
            cursor: pointer;
          }
        }
        .grid-content {
          display: flex;
          align-items: center;
          margin-bottom: 16px;
          .img {
            width: 32px;
            height: 32px;
            img {
              display: block;
              width: 32px;
              height: 32px;
              border-radius: 50%;
              border: 1px solid #e7e7e7;
              box-sizing: border-box;
            }
          }
          p {
            margin-top: 6px;
            margin-left: 10px;
            text-align: center;
            font-size: 12px;
            color: #000000;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            line-height: 12px;
          }
        }
      }
    }
  }
  .dialog-complaint {
    /deep/ {
      .el-dialog {
        padding: 20px 24px 24px 24px;
      }
      .el-dialog__header {
        padding: 0;
        margin-bottom: 16px;
      }
      .el-dialog__body {
        padding: 0;
        p {
          line-height: 24px;
        }
      }
      .el-dialog__footer {
        padding: 24px 0 0 0;
      }
    }
  }
}
</style>
